"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClient = void 0;
var client_1 = require("@apollo/client");
var error_1 = require("@apollo/client/link/error");
var cross_fetch_1 = __importDefault(require("cross-fetch"));
var _1 = require(".");
var retry_1 = require("@apollo/client/link/retry");
var getClient = function () {
    var ACCOUNT_SERVICE_URI = process.env.REACT_APP_ACCOUNT_SERVICE_URI || "http://localhost:8083";
    var retryIf = function (error, operation) {
        var doNotRetryCodes = [500, 400];
        return !!error && !doNotRetryCodes.includes(error.statusCode);
    };
    var retryLink = new retry_1.RetryLink({
        delay: {
            initial: 100,
            max: 2000,
            jitter: true,
        },
        attempts: {
            max: 5,
            retryIf: retryIf,
        },
    });
    var httpLink = new client_1.HttpLink({
        uri: "".concat(ACCOUNT_SERVICE_URI, "/graphql"),
        fetch: cross_fetch_1.default,
    });
    var errorLink = (0, error_1.onError)(function (_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError;
        if (graphQLErrors) {
            graphQLErrors.forEach(function (_a) {
                var message = _a.message, locations = _a.locations, path = _a.path, extensions = _a.extensions;
                if (message === "Token is invalid or has expired" &&
                    extensions.code === "UNAUTHORIZED") {
                    sessionStorage.clear();
                    document.location.reload();
                }
                console.log("[GraphQL error]: Message: ".concat(message, ", Location: ").concat(locations, ", Path: ").concat(path));
            });
        }
        if (networkError)
            console.log("[Network error]: ".concat(networkError));
    });
    var authMiddleware = new client_1.ApolloLink(function (operation, forward) {
        // add the authorization to the headers
        operation.setContext({
            headers: {
                token: (0, _1.getToken)(),
            },
        });
        return forward(operation);
    });
    return new client_1.ApolloClient({
        cache: new client_1.InMemoryCache(),
        link: client_1.ApolloLink.from([
            retryLink,
            errorLink,
            authMiddleware,
            httpLink,
        ]),
    });
};
exports.getClient = getClient;
//# sourceMappingURL=gqlClient.js.map